export const REACTION_TYPES = {
    LIKE: 1,
    WOW: 2,
    ENVY: 3,
    LOVE: 4,
};